import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { MotionLightbox } from "../../../../components/motion";

// Photo viewer for the fleet-type gallery. Clicking the backdrop (outside the
// photo and controls) or pressing Esc closes it.
export const PreviewCar = ({ images, setPreviewImage, previewImage }) => {
  const shouldReduceMotion = useReducedMotion();

  const currentIndex = images.findIndex((image) => image === previewImage);
  const close = () => setPreviewImage(null);
  const showPrev = () =>
    setPreviewImage(currentIndex <= 0 ? images[images.length - 1] : images[currentIndex - 1]);
  const showNext = () =>
    setPreviewImage(currentIndex === images.length - 1 ? images[0] : images[currentIndex + 1]);

  return (
    <MotionLightbox show={Boolean(previewImage)} onClose={close} className="tw:p-4">
      <button
        type="button"
        aria-label="Close"
        className="tw:absolute tw:top-4 tw:right-4 tw:z-[1060] tw:text-white tw:text-4xl! tw:leading-none tw:cursor-pointer"
        onClick={close}
      >
        <i className="bi bi-x"></i>
      </button>

      <button
        type="button"
        aria-label="Previous"
        className="tw:absolute tw:left-4 tw:z-[1060] tw:rounded-full tw:bg-black tw:w-9 tw:h-9 tw:flex tw:items-center tw:justify-center tw:cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          showPrev();
        }}
      >
        <FiArrowLeft color="#ffffff" size={20} />
      </button>

      {/* Cross-fade between photos when using the arrows. */}
      <AnimatePresence mode="wait" initial={false}>
        <motion.img
          key={previewImage}
          src={previewImage}
          alt="Preview"
          className="tw:max-h-[85vh] tw:max-w-[85vw] tw:object-contain tw:rounded-md"
          onClick={(e) => e.stopPropagation()}
          initial={{ opacity: 0, scale: shouldReduceMotion ? 1 : 0.97 }}
          animate={{ opacity: 1, scale: 1, transition: { duration: 0.3, ease: [0.22, 1, 0.36, 1] } }}
          exit={{ opacity: 0, transition: { duration: 0.15 } }}
        />
      </AnimatePresence>

      <button
        type="button"
        aria-label="Next"
        className="tw:absolute tw:right-4 tw:z-[1060] tw:rounded-full tw:bg-black tw:w-9 tw:h-9 tw:flex tw:items-center tw:justify-center tw:cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          showNext();
        }}
      >
        <FiArrowRight color="#ffffff" size={20} />
      </button>
    </MotionLightbox>
  );
};
